import { jsx } from 'react/jsx-runtime';

function Shadow({
  height,
  width,
  fill,
  radius
}) {
  return /*#__PURE__*/jsx("rect", {
    height: height,
    width: width,
    fill: fill,
    ry: radius,
    y: 3,
    x: 3,
    opacity: 0.5
  });
}

export { Shadow };
